import { Attendance } from "components/atendimentos-components/atendimento-form/types";
import { openModalConfirm } from "components/modal-confirm-new";
import { openModalError } from "components/modal-error";
import { Dispatch, SetStateAction } from "react";
import { getErrorPadrao, mapObject } from ".";
import { AttendanceActionsTypes } from "../../../../../contexts/attendance-context/actions-reducer";
import { KeyForward } from "./types";
import apiIn100 from "api/api-in100";
import { parseIn100SituacaoBeneficioToAttendanceFormat } from "components/consulta-in100-components/utils";

export function in100Map(
  data: any,
  dispatch: Dispatch<AttendanceActionsTypes>,
  attendance: Attendance
) {
  let margens = attendance.margens! || {};
  data.possuiCartaoRmc = data.margemDisponivelCartao === 0;
  data.possuiCartaoBeneficio = data.margemDisponivelRcc === 0;
  data.contaCorrente1 = data.contaCorrente;

  const keyForward: KeyForward<Attendance> = {
    cpf: (data) => {
      if (data != null) {
        data = `${data}`.trim();
        while (data.length < 11) data = "0" + data;
      }
      return { data, field: "cpf", assignJson: { flag: "HOT" } };
    },
    cbcIfPagadora: (data) => {
      return {
        field: "codBancoPagamento",
        data,
        assignJson: { flag: "HOT" },
      };
    },
    especieBeneficio: (data) => {
      return { data, field: "especieNB", assignJson: { flag: "HOT" } };
    },
    nomeBeneficiario: (data) => {
      return { data, field: "nome", assignJson: { flag: "HOT" } };
    },
    dataNascimento: (data) => ({
      data: data ? new Date(data).toLocaleDateString() : undefined,
      field: "dataNascimento",
      assignJson: { flag: "HOT" },
    }),
    ufPagamento: (data) => {
      return { data, field: "ufNB", assignJson: { flag: "HOT" } };
    },
    contaCorrente: (data) => {
      if (typeof data === "string") {
        data = data.trim();
        data = data.slice(0, data.length - 1);
      }
      return { data, field: "contaPagamento", assignJson: { flag: "HOT" } };
    },
    contaCorrente1: (data) => {
      if (typeof data === "string") data = data[data.length - 1];
      return { data, field: "dvContaPagamento", assignJson: { flag: "HOT" } };
    },
    pensaoAlimenticia: (data) => ({
      data: !!data,
      field: "pensaoAlimenticia",
      assignJson: { flag: "HOT" },
    }),
    possuiRepresentanteLegal: (data) => ({
      data: !!data,
      field: "possuiRepresentante",
      assignJson: { flag: "HOT" },
    }),
    // valorLimiteCartao: "valor",
    bloqueadoParaEmprestimo: (data) => {
      return {
        data,
        field: "bloqueadoEmprestimo",
        assignJson: { flag: "HOT" },
      };
    },
    nomeRepresentanteLegal: (data) => {
      return {
        data,
        field: "nomeRepresentanteLegal",
        assignJson: { flag: "HOT" },
      };
    },
    cpfRepresentanteLegal: (data) => {
      return {
        data,
        field: "cpfRepresentanteLegal",
        assignJson: { flag: "HOT" },
      };
    },
    elegivelEmprestimo: (data) => {
      return {
        data,
        field: "elegivelEmprestimo",
        assignJson: { flag: "HOT" },
      };
    },
    margemDisponivel: (value) => {
      margens = { ...margens, valorMargemLivreNovo: value };
      return {
        data: margens,
        field: "margens",
        assignJson: {
          attendanceKeyPath: "margens.valorMargemLivreNovo",
          flag: "HOT",
        },
      };
    },
    margemDisponivelCartao: (value) => {
      margens = { ...margens, valorMargemCartaoRMC: value };
      return {
        data: margens,
        field: "margens",
        assignJson: {
          flag: "HOT",
          attendanceKeyPath: `margens.valorMargemCartaoRMC`,
        },
      };
    },
    margemDisponivelRcc: (value) => {
      margens = { ...margens, valorMargemCartaoRCC: value };
      return {
        data: margens,
        field: "margens",
        assignJson: {
          flag: "HOT",
          attendanceKeyPath: `margens.valorMargemCartaoRCC`,
        },
      };
    },
    possuiCartaoRmc: (value) => {
      return {
        data: value,
        field: "possuiCartaoRmc",
        assignJson: { flag: "HOT" },
      };
    },
    possuiCartaoBeneficio: (value) => {
      return {
        data: value,
        field: "possuiCartaoBeneficio",
        assignJson: { flag: "HOT" },
      };
    },
    tipoCredito: (data) => {
      if (data === "1") data = "CARTAO_MAGNETICO";
      else if (data === "2") data = "CONTA_CORRENTE";
      else data = null;
      return { data, field: "tipoPagamento", assignJson: { flag: "HOT" } };
    },
    agenciaPagadora: (data) => {
      return { data, field: "agenciaPagamento", assignJson: { flag: "HOT" } };
    },
    dataDespachoBeneficio: (data: string | null) => {
      if (data?.includes("-")) data = data.split("-").reverse().join("/");
      return { data, field: "ddb", assignJson: { flag: "HOT" } };
    },
    situacaoBeneficio: (data) => {
      data = parseIn100SituacaoBeneficioToAttendanceFormat[data ?? ""];
      return { data, field: "situacaoNB", assignJson: { flag: "HOT" } };
    },
  };

  mapObject({ keyForward, data, dispatch });
}

export async function in100(
  dispatch: Dispatch<AttendanceActionsTypes>,
  formValues: Attendance,
  loading: Dispatch<SetStateAction<boolean>>,
  { signal }: AbortController
) {
  const { nb, cpf } = formValues;
  loading(true);
  try {
    const { data } = await apiIn100.get(`/consulta/multicorban/in100-hot`, {
      signal,
      params: {
        beneficio: nb,
        cpf: cpf,
      },
    });
    const parsed = JSON.parse(data.resultado);
    openModalConfirm({
      onConfirm: () => {
        in100Map(parsed, dispatch, formValues);
      },
      message: "Deseja sobrescrever com os dados da consulta HOT?",
    });
  } catch (e: any) {
    const { msgInterface } = getErrorPadrao(e);
    openModalError({
      message:
        msgInterface ?? "Erro ao consultar Consultas HOT",
    });
  } finally {
    loading(false);
  }
}
